import React from "react";
import { useForm } from "react-hook-form";
import { CancelButton, FormButton } from "../../../../components/Botton";
import Loader from "../../../../components/Loader";
import { IAddBanner } from "../../Banner.props";
import useAddBanner from "./useAddBanner";

const AddBanner: React.FC = () => {
  const {
    formData,
    loading,
    handleFileChange,
    handleChange,
    handleSubmit,
    handleCancel,
    removeImage,
  } = useAddBanner();
  const {
    register,
    handleSubmit: useFormSubmit,
    formState: { errors },
  } = useForm<IAddBanner>();

  return (
    <div className="flex flex-col items-center w-full h-screen p-8">
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full">
        <div className="border-b-2 w-[100%]">
          <h1 className="text-3xl mb-2 text-gray-700 ml-5">Add Banner</h1>
        </div>
        {loading && <Loader />}
        <form onSubmit={useFormSubmit(handleSubmit)} className="space-y-6">
          <fieldset className="m-2 rounded border-opacity-60 bg-white">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 m-4">
              <div>
                <label
                  className="block text-gray-700 text-base font-semibold mb-2"
                  htmlFor="image"
                >
                  Image:
                </label>
                <input
                  className="appearance-none border rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
                  type="file"
                  id="image"
                  {...register("image", { required: true })}
                  onChange={handleFileChange}
                />
                {errors.image && (
                  <span className="text-red-500 text-xs italic">
                    Image field is required
                  </span>
                )}
                {/* Display the selected image */}
                {formData.image instanceof File && (
                  <div className="mt-4">
                    <img
                      src={URL.createObjectURL(formData.image)}
                      alt="Selected"
                      className="h-32 w-full object-cover rounded"
                    />
                    <button
                      type="button"
                      onClick={removeImage}
                      className="mt-2 text-red-600 hover:text-red-800"
                    >
                      Remove Image
                    </button>
                  </div>
                )}
              </div>
              <div>
                <label
                  className="block text-gray-700 text-base font-semibold mb-2"
                  htmlFor="link"
                >
                  Link (Optional):
                </label>
                <input
                  className="appearance-none border rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
                  type="text"
                  id="link"
                  name="link"
                  value={formData.link || ""}
                  onChange={handleChange}
                  placeholder="https://example.com?param1=value1&param2=value2"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Enter a URL with parameters if needed
                </p>
              </div>
            </div>
          </fieldset>
          <div className="flex justify-start mt-6 ml-10">
            <FormButton className="py-2 px-4 rounded mr-4" type="submit">
              ADD
            </FormButton>
            <CancelButton
              className="py-2 px-4 rounded"
              onClick={handleCancel}
              type="button"
            >
              Cancel
            </CancelButton>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddBanner;
